(() => {
  if (window.SNProductTrustStrip) { window.SNProductTrustStrip.init(); return; }
  const rendered = new WeakMap();
  const strips = new Set();
  function render(strip) {
    const market = window.SNMarket?.state;
    // Keep the country/currency of this server-rendered section, including quick view.
    const currency = strip.dataset.currency || market?.currency;
    const locale = strip.dataset.locale || document.documentElement.lang || 'en';
    const now = new Date();
    const signature = [currency, locale, now.toDateString(), strip.dataset.handling, strip.dataset.min, strip.dataset.max].join('|');
    if (rendered.get(strip) === signature) return;
    const target = strip.querySelector('[data-sn-product-trust-date]');
    if (target) {
      const handling = Math.max(0, Number(strip.dataset.handling) || 0);
      const minimum = Math.max(1, Number(strip.dataset.min) || 1);
      const maximum = Math.max(minimum, Number(strip.dataset.max) || minimum);
      let formatter;
      try { formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }); }
      catch (_) { formatter = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }); }
      const date = (days) => { const d = new Date(now); d.setDate(d.getDate() + days); return formatter.format(d); };
      target.textContent = date(handling + minimum) + ' – ' + date(handling + maximum);
    }
    // Keep the initial server-translated copy. Swap only when display currency changes.
    if (currency !== strip.dataset.currency) {
      const copies = strip.querySelector('[data-sn-trust-copies]')?.content;
      const copy = copies && ([...copies.querySelectorAll('[data-currency]')].find((node) => node.dataset.currency === currency) || copies.querySelector('[data-currency="default"]'));
      const output = strip.querySelector('[data-sn-trust-shipping]');
      if (copy && output) output.replaceChildren(...[...copy.childNodes].map((node) => node.cloneNode(true)));
      strip.dataset.currency = currency;
    }
    rendered.set(strip, signature);
  }
  function init(root = document) {
    const register = strip => { strips.add(strip); render(strip); };
    if (root.matches?.('[data-sn-product-trust]')) register(root);
    root.querySelectorAll?.('[data-sn-product-trust]').forEach(register);
  }
  function refresh() {
    strips.forEach(strip => { if (strip.isConnected) render(strip); else strips.delete(strip); });
  }
  window.SNProductTrustStrip = { init };
  init();
  document.addEventListener('sn:market-change', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  // One scan per inserted subtree, not one scan per mutation inside every App.
  const pending = new Set();
  let frame;
  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.target.closest?.('[data-sn-product-trust]')) return;
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(node.tagName)) pending.add(node);
      });
    });
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach(node => {
        if (!node.isConnected) return;
        let ancestor = node.parentElement;
        while (ancestor) { if (pending.has(ancestor)) return; ancestor = ancestor.parentElement; }
        init(node);
      });
      pending.clear();
      strips.forEach(strip => { if (!strip.isConnected) strips.delete(strip); });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
